const PARTNERS_URL = '/partners';

export function partnersApi(partnerId?: string) {
  if (partnerId) {
    return `${PARTNERS_URL}/${partnerId}`;
  }

  return PARTNERS_URL;
}

export function partnersTrends() {
  return `${PARTNERS_URL}/trends`;
}

export function partnersWithoutStatistic() {
  return `${PARTNERS_URL}/list`;
}

export function partnersGeoECPM(partnerId: string) {
  return `${partnersApi(partnerId)}/geo-ecpm`;
}
